import { Component } from "@angular/core";
import { ExportBase } from "../export-base";
import { provideTranslocoScope, TranslocoPipe } from "@jsverse/transloco";

@Component({
    selector: "export-users",
    templateUrl: "./export-users.component.html",
    styleUrls: ["./export-users.component.scss"],
    providers: [provideTranslocoScope("export")],
    imports: [TranslocoPipe]
})
export class ExportUsersComponent extends ExportBase {
}
